export const BookingAccordionEnum = Object.freeze({
    HowArrive: 'asdf-qweh-hfgs',
})
